import { PermissionType } from 'enums/permissionType.enum';
import { PageURL } from './pageURL';

const APPLICATION_ACCESS_ROLES: PermissionType[] = [
  PermissionType.ADMIN,
  PermissionType.BROKER,
  PermissionType.BROKER_SALES,
  PermissionType.ANALYST,
];

export function getDefaultLandingPageUrl(userRoles: PermissionType[]): PageURL {
  if (APPLICATION_ACCESS_ROLES.some(role => userRoles.includes(role))) {
    return PageURL.APPLICATIONS;
  }

  if (userRoles.includes(PermissionType.FINANCE)) {
    return PageURL.PRODUCTS;
  }

  return PageURL.APPLICATIONS;
}
